<template>
  <a
    class="compliance-brain-menu"
    :href="COMPLIANCE_BRAIN_URL"
    target="_blank"
    rel="noopener noreferrer"
    @click="prepareLink"
    @auxclick="prepareLink"
    @contextmenu="prepareLink"
  >
    <svg
      class="compliance-brain-icon"
      width="20"
      height="20"
      viewBox="0 -3 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2622 3.23438L15.4095 11.3663L23.5414 14.5136L15.4095 17.6609L12.2622 25.7928L9.11491 17.6609L0.982956 14.5136L9.11491 11.3663L12.2622 3.23438Z"
        fill="currentColor"
      />
      <path
        d="M24.4446 0L26.2797 4.73992L31.0196 6.57501L26.2797 8.4101L24.4446 13.1501L22.6095 8.4101L17.8695 6.57501L22.6095 4.73992L24.4446 0Z"
        fill="currentColor"
      />
    </svg>
    <span class="compliance-brain-title">合规大脑</span>
    <span class="compliance-brain-tag">Agent</span>
  </a>
</template>

<script>
import { COMPLIANCE_BRAIN_URL, getComplianceBrainUrl } from '@/utils/complianceBrain';

export default {
  data() {
    return { COMPLIANCE_BRAIN_URL };
  },
  methods: {
    prepareLink(event) {
      event.currentTarget.href = getComplianceBrainUrl();
    },
  },
};
</script>

<style scoped lang="less">
.compliance-brain-menu {
  display: flex;
  align-items: center;
  padding: 11px 20px 11px 34px;
  color: #3190ff;
}

.compliance-brain-icon {
  flex: none;
  margin-left: -2px;
  margin-right: 8px;
}

.compliance-brain-title {
  white-space: nowrap;
}

.compliance-brain-tag {
  flex: none;
  height: 16px;
  line-height: 16px;
  margin-left: 6px;
  padding: 0 4px;
  border-radius: 4px;
  background: linear-gradient(90deg, #2cbaff 0%, #32e0b4 100%);
  color: #fff;
  font-size: 12px;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ComplianceBrainMenu.vue